import { render, staticRenderFns } from "./KnowledgeCard.vue?vue&type=template&id=6b13ee0c&scoped=true"
import script from "./KnowledgeCard.vue?vue&type=script&lang=js"
export * from "./KnowledgeCard.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeCard.vue?vue&type=style&index=0&id=6b13ee0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13ee0c",
  null
  
)

export default component.exports